import React, { useCallback } from 'react';

// debounce function
const debounce = (func, wait = 200) => {
    let timeout;
    let controller;
    function executedFunction(...args) {
        const later = () => {
            func(...args, controller?.signal); // for functions that accept signal as a parameter
        };
        clearTimeout(timeout);
        controller?.abort(); // abort the api call if the dependencies change
        controller = new AbortController();
        timeout = setTimeout(later, wait);
    };
    executedFunction.cancel = function() {
        clearTimeout(timeout);
        controller?.abort();
    }
    return executedFunction;
};

function useDebounce(callback, delay = 1000, deps = []) {
    const debouncedCallback = useCallback(debounce(callback, delay), [delay, ...deps]);

    React.useEffect(() => {
        return () => {
            debouncedCallback.cancel?.(); // cancel any pending calls if the component gets unmounted or when any dependencies change
        };
    }, [delay, ...deps]);

    return debouncedCallback;
}

export default useDebounce;

// import React, { useCallback } from 'react';

// // debounce function
// const debounce = (func, wait = 200) => {
//     let timeout;
//     return function executedFunction(...args) {
//         const later = () => {
//             clearTimeout(timeout);
//             func(...args);
//         };
//         clearTimeout(timeout);
//         timeout = setTimeout(later, wait);
//     };
// };

// function useDebounce(callback, delay = 1000, deps = []) {
//     const debouncedCallback = useCallback(debounce(callback, delay), [delay, ...deps]);

//     React.useEffect(() => {
//         return () => {
//             debouncedCallback.cancel?.(); // Optional chaining to avoid undefined errors
//         };
//     }, [delay, ...deps]);

//     return debouncedCallback;
// }

// export default useDebounce;
